import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.TextOnlySlice} TextOnlySlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TextOnlySlice>} TextOnlyProps
 * @type {import("react").FC<TextOnlyProps>}
 */
const TextOnly = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`framing-xs padding-x flex flex-col gap-6 md:gap-10 xl:gap-20 ${index === 0 ? "padding-y-first" : "padding-y"} items-center`}
    >
      {isFilled.richText(slice.primary.text) && (
        <div className="flex flex-col gap-4 underline-custom">
          <PrismicRichText
            field={slice.primary.text}
            components={{
              heading1: ({ children }) => <h1 className="h2 mt-6 text-sky-blue">{children}</h1>,
              heading2: ({ children }) => <h2 className="h3 mt-4 text-blue">{children}</h2>,
              heading3: ({ children }) => <h3 className="h3 mt-2">{children}</h3>,
              paragraph: ({ children }) => <p className="p-sm">{children}</p>,
              list: ({ children }) => <ul className="list-puce-ams">{children}</ul>,
              listItem: ({ children }) => <li className="mb-2 last:mb-0">{children}</li>,
              oList: ({ children }) => <ol className="list-decimal list-inside">{children}</ol>,
              oListItem: ({ children }) => <li className="mb-2 last:mb-0">{children}</li>,
            }}
          />
        </div>
      )}

    </section>
  );
};

export default TextOnly;
